import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Reveal from "@/components/Reveal";
import { ArrowRight, BookOpen } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogSection() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/posts`)
      .then((res) => setPosts(res.data))
      .catch(() => setPosts([]));
  }, []);

  if (!posts.length) return null;

  return (
    <section id="blog" className="py-20 sm:py-28 bg-white" data-testid="blog-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Owner Resources</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            Short-Term Rental Insights &amp; Guides
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#5a5a5a] max-w-2xl">
            Practical reading for property owners — co-hosting, vacation rental management, and
            getting the most from your home.
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-6 sm:gap-8">
          {posts.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.08}>
              <Link
                to={`/blog/${post.slug}`}
                data-testid={`blog-card-${post.slug}`}
                className="group flex h-full flex-col bg-[#F7F7F9] border border-[#EBEBEB] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10)] hover:bg-white"
              >
                <div className="flex items-center gap-2 text-xs font-bold tracking-wide uppercase text-[#FF5A5F]">
                  <BookOpen className="w-4 h-4" />
                  {new Date(post.published_at + "T00:00:00").toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </div>
                <h3 className="mt-3 text-xl sm:text-2xl font-bold text-[#222] group-hover:text-[#FF5A5F] transition-colors duration-200 leading-snug">
                  {post.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#5a5a5a] flex-1">{post.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-[#FF5A5F]">
                  Read the guide
                  <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
